import React, { useEffect, useRef } from "react";
import { prefersReducedMotion, useInView } from "@/pages/homepage/hooks/useHomepageEffects";

export function StatsSection() {
  const { ref: sectionRef, visible } = useInView(0.12);
  const ref1 = useRef<HTMLSpanElement>(null);
  const ref2 = useRef<HTMLSpanElement>(null);
  const ref3 = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (prefersReducedMotion) {
      if (ref1.current) ref1.current.textContent = "25";
      if (ref2.current) ref2.current.textContent = "160";
      if (ref3.current) ref3.current.textContent = "30";
      return;
    }
    if (!visible) {
      if (ref1.current) ref1.current.textContent = "0";
      if (ref2.current) ref2.current.textContent = "0";
      if (ref3.current) ref3.current.textContent = "0";
      return;
    }

    const targets = [25, 160, 30];
    const refs = [ref1, ref2, ref3];
    const duration = 1800;
    const start = performance.now();
    let rafId: number;

    const tick = (now: number) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);

      targets.forEach((target, i) => {
        const el = refs[i]?.current;
        if (el) el.textContent = Math.round(eased * target).toString();
      });

      if (progress < 1) rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [visible]);

  return (
    <section ref={sectionRef as React.RefObject<HTMLElement>} className="w-full bg-ink py-20">
      <div className="flex w-full flex-wrap justify-center gap-y-8">
        <div className="flex flex-col items-center gap-2 px-8 md:px-14 lg:px-20">
          <div className="flex items-end gap-1">
            <span
              ref={ref1}
              className="inline-flex min-w-[2ch] justify-end font-bold leading-none tracking-[-3.2px] text-snow tabular-nums"
              style={{ fontSize: "clamp(44px,6vw,80px)" }}
            >
              0
            </span>
            <span className="mb-2 font-bold leading-none text-snow" style={{ fontSize: "clamp(22px,3vw,40px)" }}>년</span>
          </div>
          <span className="font-medium text-white/40" style={{ fontSize: "clamp(14px,1.5vw,18px)" }}>년 역사</span>
        </div>

        <div className="flex flex-col items-center gap-2 px-8 md:px-14 lg:px-20">
          <div className="flex items-end gap-1">
            <span
              ref={ref2}
              className="inline-flex min-w-[3ch] justify-end font-bold leading-none tracking-[-3.2px] text-snow tabular-nums"
              style={{ fontSize: "clamp(44px,6vw,80px)" }}
            >
              0
            </span>
            <span className="mb-2 font-bold leading-none text-snow" style={{ fontSize: "clamp(22px,3vw,40px)" }}>명+</span>
          </div>
          <span className="font-medium text-white/40" style={{ fontSize: "clamp(14px,1.5vw,18px)" }}>가입 부원</span>
        </div>

        <div className="flex flex-col items-center gap-2 px-8 md:px-14 lg:px-20">
          <div className="flex items-end gap-1">
            <span
              ref={ref3}
              className="inline-flex min-w-[2ch] justify-end font-bold leading-none tracking-[-3.2px] text-snow tabular-nums"
              style={{ fontSize: "clamp(44px,6vw,80px)" }}
            >
              0
            </span>
            <span className="mb-2 font-bold leading-none text-snow" style={{ fontSize: "clamp(22px,3vw,40px)" }}>개+</span>
          </div>
          <span className="font-medium text-white/40" style={{ fontSize: "clamp(14px,1.5vw,18px)" }}>개 프로그램</span>
        </div>
      </div>
    </section>
  );
}
